/* Behaviour for the custom minery-* sections.
   No dependencies. Safe to load more than once and safe to re-run after the
   theme editor swaps a section in. */

(function () {
  'use strict';

  /* ----------------------------------------------------------------------
     Slider: any [data-m-slider] with [data-m-slide] children and an optional
     [data-m-dots] container. Autoplay is opt-in via data-m-autoplay="ms".
     ---------------------------------------------------------------------- */

  function initSlider(root) {
    if (root.dataset.mReady === '1') return;
    root.dataset.mReady = '1';

    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-m-slide]')
    ).filter(function (el) {
      return el.closest('[data-m-slider]') === root;
    });
    if (slides.length === 0) return;

    /* Optional per-slide backgrounds that change with the slide. */
    var media = Array.prototype.slice.call(
      root.querySelectorAll('[data-m-slide-media], [data-m-slide-hs]')
    ).filter(function (el) {
      return el.closest('[data-m-slider]') === root;
    });
    var hsLayers = media.filter(function (el) { return el.hasAttribute('data-m-slide-hs'); });
    media = media.filter(function (el) { return el.hasAttribute('data-m-slide-media'); });

    var dotWrap = root.querySelector('[data-m-dots]');
    var dots = [];
    var index = 0;
    slides.forEach(function (s, i) {
      if (s.classList.contains('is-active')) index = i;
    });

    if (dotWrap && slides.length > 1) {
      dotWrap.innerHTML = '';
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'm-dot';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () {
          go(i);
          halt();
        });
        dotWrap.appendChild(b);
        dots.push(b);
      });
    }

    /* Previous / next buttons and touch swipe. Both are the shopper taking
       control, so like a dot they stop autoplay for the rest of the visit.
       Swipe is opt-in (data-m-swipe) and touch-only: a mouse drag on the
       hero would otherwise end in a click on the whole-banner link. */
    if (slides.length > 1) {
      var prevBtn = root.querySelector('[data-m-prev]');
      var nextBtn = root.querySelector('[data-m-next]');
      if (prevBtn && prevBtn.closest('[data-m-slider]') === root) {
        prevBtn.addEventListener('click', function () { go(index - 1); halt(); });
      }
      if (nextBtn && nextBtn.closest('[data-m-slider]') === root) {
        nextBtn.addEventListener('click', function () { go(index + 1); halt(); });
      }

      if (root.hasAttribute('data-m-swipe')) {
        var sx = 0, sy = 0, tracking = false;
        root.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) { tracking = false; return; }
          tracking = true;
          sx = e.touches[0].clientX;
          sy = e.touches[0].clientY;
        }, { passive: true });
        root.addEventListener('touchend', function (e) {
          if (!tracking) return;
          tracking = false;
          var t = e.changedTouches[0];
          var dx = t.clientX - sx, dy = t.clientY - sy;
          // A clear sideways flick only: at least 40px, and more across than
          // down, so scrolling the page past the hero never changes slide.
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
          go(dx < 0 ? index + 1 : index - 1);
          halt();
        }, { passive: true });
      }
    }

    function go(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === index);
        s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });
      media.forEach(function (m, i) {
        m.classList.toggle('is-active', i === index);
      });
      hsLayers.forEach(function (m, i) {
        m.classList.toggle('is-active', i === index);
        if (i !== index) {
          m.querySelectorAll('.m-hs__pt.is-open').forEach(function (pt) { pt.classList.remove('is-open'); });
        }
      });
    }

    var timer = null;
    var every = 0;
    var halted = false;

    /* Why these are state and not just stop() calls: three separate things
       pause rotation — the pointer, the focus ring and the tab going to the
       background — and they overlap. Returning from a background tab used to
       call start() unconditionally, so a shopper reading the slide with the
       cursor resting on it had rotation resume underneath them the moment
       they came back. start() has to know it is still paused for another
       reason, which a bare stop()/start() pair cannot express. */
    var pointerIn = false;
    var focusIn = false;

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      if (timer || halted || pointerIn || focusIn) return;
      if (every <= 0 || slides.length < 2) return;
      timer = setInterval(function () {
        go(index + 1);
      }, every);
    }

    /* Clicking a dot is the shopper taking control on purpose, so rotation
       stops for the rest of the visit. Hovering and tab-switching are only a
       pause — those come back. */
    function halt() {
      halted = true;
      stop();
    }

    go(index);

    every = parseInt(root.dataset.mAutoplay || '0', 10);
    var reduced =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (every > 0 && slides.length > 1 && !reduced) {
      start();

      /* This used to be a bare `mouseenter -> stop` with nothing to restart
         it, so on a desktop — where the cursor sits over a full-width hero
         most of the time — rotation died seconds after load and never
         returned. Pausing on hover is right; never resuming was the bug.
         It also satisfies WCAG 2.2.2, which wants a way to pause anything
         that auto-updates for more than five seconds. */
      root.addEventListener('mouseenter', function () {
        pointerIn = true;
        stop();
      });
      root.addEventListener('mouseleave', function () {
        pointerIn = false;
        start();
      });

      /* Same courtesy for the keyboard: tabbing to a slide's call to action
         should not have it slide out from under the focus ring. */
      root.addEventListener('focusin', function () {
        focusIn = true;
        stop();
      });
      root.addEventListener('focusout', function (e) {
        if (!root.contains(e.relatedTarget)) {
          focusIn = false;
          start();
        }
      });

      /* setInterval keeps firing in a background tab, so without this a
         shopper who switches away for a minute comes back to a hero that has
         flipped ten times and is mid-crossfade. */
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });
    }
  }

  /* ----------------------------------------------------------------------
     Header scroll edge

     The header is a translucent layer that page content passes underneath,
     and it carries no hairline of its own. Instead a short gradient fades in
     where the two actually overlap — the only moment a separation is doing
     any work. At the top of the page there is nothing under the bar, so
     there is nothing to separate and no edge is drawn.

     The listener is passive and the read is deferred to the next frame, so
     scrolling never waits on it. Guarded by a dataset flag because
     minery.css and minery.js are both emitted once per minery-* section and
     this file can therefore run more than once on a page.
     ---------------------------------------------------------------------- */

  function initHeaderEdge() {
    var header = document.querySelector('.m-header');
    if (!header || header.dataset.mEdge === '1') return;
    header.dataset.mEdge = '1';

    var queued = false;

    function apply() {
      queued = false;
      if (window.scrollY > 4) header.setAttribute('data-scrolled', '');
      else header.removeAttribute('data-scrolled');
    }

    window.addEventListener(
      'scroll',
      function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(apply);
      },
      { passive: true }
    );

    /* A reload partway down the page starts already scrolled. */
    apply();
  }

  /* ----------------------------------------------------------------------
     Purchase notifications.

     Shopify's storefront has no access to other customers' orders, so a
     theme cannot know about real purchases. This renders only entries the
     merchant has entered themselves, and stays hidden when there are none.
     ---------------------------------------------------------------------- */

  function initNotify(root) {
    if (root.dataset.mReady === '1') return;
    root.dataset.mReady = '1';

    var items = Array.prototype.slice.call(
      root.querySelectorAll('[data-m-notice]')
    );
    if (items.length === 0) return;

    var delay = parseInt(root.dataset.mDelay || '6000', 10);
    var visible = parseInt(root.dataset.mVisible || '6000', 10);
    var i = 0;
    var dismissed = false;

    var close = root.querySelector('[data-m-notify-close]');
    if (close) {
      close.addEventListener('click', function () {
        dismissed = true;
        root.classList.remove('is-visible');
      });
    }

    function show() {
      if (dismissed) return;
      items.forEach(function (el, n) {
        el.hidden = n !== i;
      });
      root.classList.add('is-visible');
      setTimeout(function () {
        root.classList.remove('is-visible');
        i = (i + 1) % items.length;
        setTimeout(show, delay);
      }, visible);
    }

    setTimeout(show, delay);
  }

  /* ----------------------------------------------------------------------
     Mobile menu
     ---------------------------------------------------------------------- */

  function initBurger(btn) {
    if (btn.dataset.mReady === '1') return;
    btn.dataset.mReady = '1';

    var nav = document.getElementById(btn.getAttribute('aria-controls'));
    if (!nav) return;

    var mq = window.matchMedia('(max-width: 900px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var running = [];

    function stop() {
      running.forEach(function (a) { a.cancel(); });
      running = [];
    }

    /* The "fluid menu" unfold, ported from a React component: every row
       starts tucked up under the row above it and slides down to its place;
       closing folds them back up. The React original steps each item 48px
       further than the last; here the travel is capped at that same step
       (and at the row's own offset), because the Shop row is ~500px tall and
       the rows under it would otherwise cross most of the screen in 300ms.
       Earlier rows sit above later ones so each emerges from under the one
       before. */
    function fluid(open, done) {
      stop();
      var rows = nav.querySelectorAll(':scope > .m-nav__item, :scope > .m-nav__extra');
      if (!rows.length || !nav.animate || reduce.matches || !mq.matches) {
        if (done) done();
        return;
      }
      Array.prototype.forEach.call(rows, function (el, i) {
        var lift = Math.min(el.offsetTop, 48 * (i + 1));
        var stacked = { transform: 'translateY(' + -lift + 'px)', opacity: 0 };
        var placed = { transform: 'translateY(0)', opacity: 1 };
        el.style.zIndex = String(rows.length - i);
        running.push(el.animate(open ? [stacked, placed] : [placed, stacked], {
          duration: open ? 300 : 350,
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
          fill: open ? 'none' : 'forwards'
        }));
      });
      var last = running[running.length - 1];
      function finish() {
        Array.prototype.forEach.call(rows, function (el) { el.style.zIndex = ''; });
        if (done) done();
      }
      // A cancelled animation (reopened mid-close) rejects; finish either way.
      last.finished.then(finish, finish);
    }

    function set(open) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute(
        'aria-label',
        open ? btn.dataset.labelClose || 'Close menu' : btn.dataset.labelOpen || 'Menu'
      );
      if (open) {
        // The drawer hangs from the header, which sits lower while the top
        // bar is still on screen; its height is worked out from where the
        // header actually ends now. The page is locked while it is open,
        // so the value holds until it closes.
        var head = nav.closest('.m-header');
        if (head) nav.style.setProperty('--m-nav-top', Math.round(head.getBoundingClientRect().bottom) + 'px');
        nav.style.display = 'flex';
        fluid(true);
      } else if (nav.style.display) {
        fluid(false, function () {
          // Reopened while folding: leave it open.
          if (btn.getAttribute('aria-expanded') === 'true') return;
          stop();
          nav.style.display = '';
        });
      }
      // The page behind stays put while the menu is open; the menu scrolls.
      document.documentElement.classList.toggle('m-nav-lock', open);
    }

    btn.addEventListener('click', function () {
      set(btn.getAttribute('aria-expanded') !== 'true');
    });

    // Following a link, or opening the wishlist from the menu, closes it.
    // A parent with sub-categories is not followed on a phone — tapping it
    // opens its list — so it must leave the menu open.
    nav.addEventListener('click', function (e) {
      if (btn.getAttribute('aria-expanded') !== 'true') return;
      if (e.target.closest('[data-m-subparent]')) return;
      if (e.target.closest('a, [data-m-wishtoggle]')) set(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
        set(false);
        btn.focus();
      }
    });

    // Back to a desktop width with the menu open: undo the phone state.
    function onChange() { if (!mq.matches) set(false); }
    if (mq.addEventListener) mq.addEventListener('change', onChange);
  }

  /* Header third level: on a phone (no hover) tapping the parent's name
     or its chevron opens the list in place; the parent's page is the
     "All ..." link inside it. The chevron also serves a tablet tapping at
     desktop width. One delegated listener, guarded because this file can
     load more than once per page. */
  if (!window.__mSubToggle) {
    window.__mSubToggle = true;
    var subMq = window.matchMedia('(max-width: 900px)');
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var btn = e.target.closest('[data-m-subtoggle]');
      var parent = btn ? null : e.target.closest('[data-m-subparent]');
      if (!btn && !(parent && subMq.matches)) return;
      var item = (btn || parent).closest('.m-nav__subitem');
      if (!item) return;
      e.preventDefault();
      var open = !item.classList.contains('is-open');
      item.classList.toggle('is-open', open);
      var toggle = item.querySelector('[data-m-subtoggle]');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function boot(scope) {
    var ctx = scope || document;
    ctx.querySelectorAll('[data-m-slider]').forEach(initSlider);
    ctx.querySelectorAll('[data-m-notify]').forEach(initNotify);
    ctx.querySelectorAll('[data-m-burger]').forEach(initBurger);
    initHeaderEdge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  // Theme editor re-renders sections in place; re-scan when it does.
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
